module.exports = __webpack_public_path__ + "static/media/7_of_hearts.5cebf623.png";